/* eslint-disable jsx-a11y/iframe-has-title */
import { Modal } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { apiUrl } from '../../api';
import { ParcelOrderPrintProp } from '../../common/print';
import { useLocation } from 'react-router-dom';

const ParcelOrderPrint = ({ orderIds, visible, onClose, onReload }: ParcelOrderPrintProp) => {
  const location = useLocation();
  const [printPdfLoading, setPrintPdfLoading] = useState(true);
  const close = useCallback(() => {
    onClose();
    onReload();
  }, [location]);

  const printIframeUrl = useMemo(() => {
    const url = `/api/order/print?orderNos=${orderIds}`;
    return url;
  }, [orderIds, location]);

  const showPrintIframe = useCallback(() => {
    setPrintPdfLoading(false);
  }, [location]);

  return (
    <Modal title="Баримт Хэвлэх" open={visible} footer={false} width={520} onCancel={() => close()}>
      <iframe
        width="100%"
        height={600}
        src={printIframeUrl}
        frameBorder={0}
        onLoad={showPrintIframe}
        style={{ visibility: printPdfLoading ? 'hidden' : 'visible' }}
      />
    </Modal>
  );
};

export default ParcelOrderPrint;
